// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"yourWatchlist_wrapper__ZRyMy","yourWatchlist":"yourWatchlist_yourWatchlist__UPBoz"};